import React, { useEffect, useState, Fragment, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import '../../ReassignQueuePage.scss'
import HrbTranslate from '../../../../components/language/HrbTranslate';
import { SummaryIcons } from '../../icons/SummaryIcons';
import districtsService from '../../../districts/services/DistrictsService';
import Lang from '../../../../components/language/services/Lang';
import manageAssociatesService from '../../../associates/services/ManageAssociatesService'
import classNames from 'classnames'
import ReassignConfirmationModal from './ReassignConfirmationModal';
import ticketService from '../../../vdo-ticket/services/manage/TicketService'
import ReassignErrorModal from './ReassignErrorModal'
import { toast, Slide } from 'react-toastify'
import EmployeeApi from '../../../../services/api/EmployeeApi';

const ReassignTableColumnHeader = (props) => {
    const history = useHistory();
    const employeeId = useSelector(state => state.accountData.employeeId);
    const [selectedDistrict, setSelectedDistrict] = useState(<HrbTranslate text={`QueuePage.Labels.ReassignAllDistricts`} />);
    const [districtFilter, setDistrictFilter] = useState("-1")
    const [districtList, setDistrictList] = useState(null);
    const [officeList, setOfficeList] = useState(null);
    const [filteredOfficeList, setFilteredOfficeList] = useState(null);
    const [officeSearchValue, setOfficeSearchValue] = useState('');
    const [districtDropdownExpanded, setDistrictDropdownExpanded] = useState(false);
    const [officeDropdownExpanded, setOfficeDropdownExpanded] = useState(false);
    const [selectedOffice, setSelectedOffice] = useState(null)
    const districtDropdownRef = useRef(null);
    const officeDropdownRef = useRef(null);
    const [confirmationModalShowing, setConfirmationModalShowing] = useState(false);
    const [showError, setShowError] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const employeeApi = EmployeeApi.create();

    const handleDistrictDropdownExpanded = () => {
        setDistrictDropdownExpanded(!districtDropdownExpanded);
    };

    const handleOfficeDropdownExpanded = () => {
        setOfficeDropdownExpanded(!officeDropdownExpanded);
        setOfficeSearchValue('');
    };

    const handleOfficeSearchStringChange = (e) => {
        setOfficeSearchValue(e);
    };

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    const handleOutsideClick = (event) => {
        if (districtDropdownRef.current && !districtDropdownRef.current.contains(event.target)) {
            setDistrictDropdownExpanded(false);
        }
        if (officeDropdownRef.current && !officeDropdownRef.current.contains(event.target)) {
            setOfficeDropdownExpanded(false);
        }
    };

    const handleInputClick = (event) => {
        event.stopPropagation();
    }

    useEffect(() => {
        const filteredOffices = officeList?.filter((d) =>
            String(d.id).toLowerCase().includes(officeSearchValue.toLowerCase()) ||
            d.city.toLowerCase().includes(officeSearchValue.toLowerCase())
        );
        setFilteredOfficeList(filteredOffices);
    }, [officeSearchValue]);

    const getDistrictList = async () => {
        var districtData = props.hasViewDistrictOfficesPermission && await districtsService.getDistricts()
        if (districtData) {
            setDistrictList(districtData)
        }
    }

    const getOfficeList = async () => {
        if (props.hasViewDistrictOfficesPermission) {
            var officeData = await manageAssociatesService.getAllMyOffices(employeeId)
            if (officeData) {
                if (districtFilter === "-1") {
                    setOfficeList(officeData)
                    setSelectedOffice(officeData && officeData.length > 0 && officeData[0].id)
                    props.onSelectedOfficeChange(officeData && officeData.length > 0 && officeData[0].id);
                }
                else {
                    const filteredOffices = officeData.filter(office => office.districtId === parseInt(districtFilter));
                    setOfficeList(filteredOffices);
                    setSelectedOffice(filteredOffices && filteredOffices.length > 0 && filteredOffices[0].id)
                    props.onSelectedOfficeChange(filteredOffices && filteredOffices.length > 0 && filteredOffices[0].id);
                }
            }
        }
        else {
            var employeeData = await employeeApi.getEmployeeInfo(employeeId)
            if (employeeData) {
                var officeId = employeeData.data.officeId;
                setSelectedOffice(officeId);
                props.onSelectedOfficeChange(officeId);
            }
        }
    }

    useEffect(() => {
        setOfficeList(null)
        getOfficeList()
    }, [districtFilter])

    useEffect(() => {
        setDistrictList(null)
        getDistrictList()

        setOfficeList(null)
        getOfficeList()

    }, [])

    const handleDistrictFilterChange = (districtId) => {
        if (districtFilter !== districtId) {
            setDistrictFilter(districtId)
        }
    }

    const handleOfficeFilterChange = (officeId) => {
        setSelectedOffice(officeId)
        props.onSelectedOfficeChange(officeId);
    }

    const showReassignConfirmationModal = () => {
        setConfirmationModalShowing(true);
    }

    const onConfirmationModalClose = () => {
        setConfirmationModalShowing(false)
    }

    const handleBulkReassignment = async () => {
        setIsLoading(true)
        let result = await ticketService.bulkAssignTickets(props.selectedTicketIds, props.selectedAssociateId, props.selectedAssociateOfficeId, false, true);
        if (result) {
            localStorage.setItem('reassignTicketIds', JSON.stringify([]));
            localStorage.setItem('pageSelections', JSON.stringify({}));
            setConfirmationModalShowing(false)
            setIsLoading(false)
            history.goBack();
            toast.success(
                <HrbTranslate text='QueuePage.Labels.ReassignmentSuccess' params={{ ticketsCount: props.selectedTicketIds?.length, AssigneeFirstName: props.selectedAssociateFirstName }} />,
                {
                    className: 'black-background-toast',
                    position: "bottom-left",
                    autoClose: 5000,
                    transition: Slide,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                }
            );
        } else {
            setShowError(true)
            setIsLoading(false)
        }
    }


    return (
        <Fragment>
            <div className='reassign-header'>
                <div className='reassign-header-component'>
                    <div className='reassign-header-label'>
                        <HrbTranslate text={`QueuePage.Labels.ReassignDistrict`} />
                    </div>
                    <div className='custom-dropdown-wrapper'>
                        <div className={!districtList || districtList?.length === 0 ? 'custom-dropdown-disabled' : 'custom-dropdown'} ref={districtDropdownRef} onClick={handleDistrictDropdownExpanded}>
                            <div className='custom-dropdown-label'>{selectedDistrict}</div>
                            <div className='custom-dropdown-chevron' >
                                {!districtList || districtList?.length === 0 ? SummaryIcons.REASSIGN_CHEVRON_DISABLED : districtDropdownExpanded ? SummaryIcons.REASSIGN_CHEVRON_EXPANDED : SummaryIcons.REASSIGN_CHEVRON_COLLAPSED}
                            </div>
                        </div>
                        {districtDropdownExpanded &&
                            <div className='custom-dropdown-expand-overlay custom-dropdown-table district-dropdown'>
                                <div onClick={() => { handleDistrictFilterChange('-1'); setSelectedDistrict(<HrbTranslate text={`QueuePage.Labels.ReassignAllDistricts`} />); }} className='custom-dropdown-table-rows district-dropdown'>
                                    <HrbTranslate text={`QueuePage.Labels.ReassignAllDistricts`} />
                                </div>
                                {districtList && districtList.length > 0 && districtList.map((d, i) =>
                                    <div onClick={() => { handleDistrictFilterChange(`${d.id}`); setSelectedDistrict(d.name); }} key={i} value={`${d.id}`} className='custom-dropdown-table-rows district-dropdown'>
                                        <span>{d.name}</span>
                                    </div>
                                )}
                            </div>
                        }
                    </div>
                </div>
                <div className='reassign-header-component'>
                    <div className='reassign-header-label'>
                        <HrbTranslate text={`QueuePage.Labels.ReassignOffice`} />
                    </div>
                    <div className='custom-dropdown-wrapper'>
                        <div onClick={handleOfficeDropdownExpanded} ref={officeDropdownRef} className={!officeList || officeList?.length === 0 ? 'custom-dropdown-disabled' : 'custom-dropdown'}>
                            <div className='custom-dropdown-label' >
                                {officeList?.length === 0 && selectedOffice === null && < HrbTranslate text={`QueuePage.Labels.ReassignNoAvailableOffices`} />}
                                {!officeList && selectedOffice !== null && selectedOffice}
                                {officeList?.length > 0 && selectedOffice}
                            </div>
                            <div className='custom-dropdown-chevron' >
                                {!officeList || officeList?.length === 0 ? SummaryIcons.REASSIGN_CHEVRON_DISABLED : officeDropdownExpanded ? SummaryIcons.REASSIGN_CHEVRON_EXPANDED : SummaryIcons.REASSIGN_CHEVRON_COLLAPSED}
                            </div>
                        </div>
                        {officeDropdownExpanded &&
                            <div className='custom-dropdown-expand-overlay'>
                                <div className='custom-dropdown-search'>
                                    <div className='custom-dropdown-search-icon'>
                                        {SummaryIcons.REASSIGN_OFFICE_SEARCH}
                                    </div>
                                    <div >
                                        <input
                                            className='custom-dropdown-search-label'
                                            type="text"
                                            placeholder={Lang.getCurrentValue('QueuePage.Labels.ReassignOfficeSearch')}
                                            value={officeSearchValue}
                                            onClick={handleInputClick}
                                            onChange={ev => handleOfficeSearchStringChange(ev.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className='custom-dropdown-table office-dropdown'>
                                    {officeList && officeList.length > 0 && (
                                        filteredOfficeList && filteredOfficeList !== null ? (
                                            filteredOfficeList.map((d, i) => (
                                                <div key={i} className='columns custom-dropdown-table-rows' onClick={() => handleOfficeFilterChange(`${d.id}`)}>
                                                    <span className='column is-2'>{d.id}</span>
                                                    <span className='column is-4'>{d.city}</span>
                                                    <span className='column is-6'>{d.streetAddress}</span>
                                                </div>
                                            ))
                                        ) : (
                                            officeList.map((d, i) => (
                                                <div key={i} className='columns custom-dropdown-table-rows' onClick={() => handleOfficeFilterChange(`${d.id}`)}>
                                                    <span className='column is-2'>{d.id}</span>
                                                    <span className='column is-4'>{d.city}</span>
                                                    <span className='column is-6'>{d.streetAddress}</span>
                                                </div>
                                            ))
                                        )
                                    )}
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className='reassign-header-button-wrapper'>
                    <div onClick={showReassignConfirmationModal} className={classNames('reassign-header-button', { 'reassign-header-button-active': props.selectedAssociateId })}>
                        <HrbTranslate className='reassign-header-button-text' text={`QueuePage.Labels.ReassignConfirmButton`} />
                    </div>
                </div>
            </div>
            {confirmationModalShowing &&
                <ReassignConfirmationModal
                    onClose={onConfirmationModalClose}
                    handleBulkReassignment={handleBulkReassignment}
                    textContent={<HrbTranslate text='QueuePage.Labels.ReassignModalContent_toAssociate' params={{ ticketsCount: props.selectedTicketIds?.length, Assignee: props.selectedAssociateName }} />}
                    isLoading={isLoading}
                />
            }
            {showError &&
                <ReassignErrorModal onClose={() => { setShowError(false) }} />
            }
        </Fragment>
    );
}

export default ReassignTableColumnHeader